import { Directive, EventEmitter, HostListener, OnInit, Output, Input } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

@Directive({
  selector: '[appThrottleClick]'
})
export class ThrottleClickDirective implements OnInit{
  @Input() throttleTime = 500;
  @Output() throttleClick = new EventEmitter();
  
  private clicks = new Subject();
  private subscription: Subscription;

  ngOnInit() {
    this.subscription = this.clicks.throttleTime(this.throttleTime).subscribe(e => this.throttleClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

}


// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/throttle-click.directive.ts